<template>
  <div>
    <!--查询条件-->
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="95px" size="mini">
        <div class="formItemBox">
          <el-form-item label="一级货主:">
            <el-select v-model="searchFrom.primaryCustomerTaxId" clearable filterable placeholder="请选择">
              <el-option v-for="(item, index) in customerData" :key="index" :label="item.custerName" :value="item.taxpayerNumber"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="二级货主:">
            <el-select v-model="searchFrom.customerTaxId" clearable filterable placeholder="请选择">
              <el-option v-for="(item, index) in customerData" :key="index" :label="item.custerName" :value="item.taxpayerNumber">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="货物类型:">
            <el-select v-model="searchFrom.productType" @change="productTypeChange" clearable placeholder="请选择" filterable >
              <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.productTypeName" :value="item.productType">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产地:">
            <el-select v-model="searchFrom.steelMillName" @change="steelMillNameChange" clearable placeholder="请选择" filterable>
              <el-option v-for="(item, index) in steelMillNameData" :key="index" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="规格:">
            <el-select v-model="searchFrom.specification" @change="specificationChange" clearable placeholder="请选择" filterable>
              <el-option v-for="(item, index) in specificationData" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="材质:">
            <el-select v-model="searchFrom.model" @change='modelChange' clearable placeholder="请选择" filterable>
              <el-option v-for="(item, index) in modelData" :key="index" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="操作时间:" >
            <div style="display: flex;">
              <el-date-picker v-model="searchFrom.createStartTime" type="datetime" placeholder="请选择"
                value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
              -
              <el-date-picker v-model="searchFrom.createEndTime" placeholder="请选择" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </div>
          </el-form-item>
        </div>
        <div class="searchBtnBox">
          <el-form-item>
            <el-button type="primary" @click="searchClick" btnCode="00cP00BB00J" v-if="btnFlg[18]">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="chongZhiClick" btnCode="00cP00BB00K" v-if="btnFlg[19]">重置</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="exportClick" btnCode="00cP00BB00L" v-if="btnFlg[20]">导出</el-button>
          </el-form-item>
        </div>
        <div style="margin:0 0 5px 10px;display: flex;">
          <div style="display: flex;">
            <div>总吨数：</div>
            <div style="color:red;">{{Number(totalAllWeight).toFixed(4)}}</div>&nbsp;&nbsp;吨
          </div>
        </div>
      </el-form>
    </div>
    <!--  表格 v-loading='tabLoading'-->
    <div class="table" :style="{ height: h }" >
      <el-table
        :data="tableList"
        ref="tableRef"
        border
        bordersize="mini"
        height="100%"
        style="width: 100%; margin-top: 10px"
        center
        @row-click="handleRowClick"
        @current-change="handleTabCurrentChange"
        :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
        :header-row-style="{ height: '45px' }"
        :row-style="{ height: '35px' }"
        highlight-current-row
      >
        <!-- <el-table-column type="selection" width="55" align="center" ></el-table-column> -->
        <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" align="center" width="220" ></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" align="center" width="220" ></el-table-column>
        <el-table-column prop="plateNumber" label="车船号" width="120" ></el-table-column>
        <el-table-column prop="warehouseName" label="仓位" width="110" ></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center" width="120" ></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" align="center" width="100" ></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" align="center" width="120" ></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center" width="70" ></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量（吨）" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="stockWeight" label="理重（吨）" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="stockPoundWeight" label="过磅净重（吨）" align="center" width="120"></el-table-column>
        <el-table-column prop="shipForecastNo" label="预报编号" width="280" ></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createUser" label="操作人" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createTime" label="操作时间" align="center" width="180">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.createTime!= '' || scope.row.createTime != undefined || scope.row.createTime != null">{{scope.row.createTime | dateFormat}}</span>
          </div></template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 40,50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {
  getRelationCustomer, // 字典客户
  getVirtualBalingList, // 货物类型、产地、规格、材质、长度、件数级联查询
  jfgetCustomerClearList // 列表
} from '@/api/wms-stock.js'
import { exportExcel } from '@/utils/fileDown.js'
import { getBtn } from '@/utils/getButton'
import { emptyFn, formatterRowEmpty } from '@/utils/util'
import DonMessage from '@/utils/message'
import {
  getStockClearRecordList, // 列表
  getStockClearRecordWeight // 吨数
} from '@/api/wms-access.js'
export default {
  data () {
    return {
      emptyFn: emptyFn,
      formatterRowEmpty: formatterRowEmpty,
      // 按钮
      btnFlg: [],
      btnArr: [
        // 入库记录
        '00cP00BB001',
        '00cP00BB002',
        '00cP00BB003',
        '00cP00BB004',
        // 进仓记录
        '00cP00BB005',
        '00cP00BB006',
        '00cP00BB007',
        // 出库记录
        '00cP00BB008',
        '00cP00BB009',
        '00cP00BB00A',
        '00cP00BB00B',
        // 转货记录
        '00cP00BB00C',
        '00cP00BB00D',
        '00cP00BB00E',
        '00cP00BB00F',
        // 移库记录
        '00cP00BB00G',
        '00cP00BB00H',
        '00cP00BB00I',
        // 亏涨记录
        '00cP00BB00J',
        '00cP00BB00K',
        '00cP00BB00L',
        // 删除记录
        '00cP00BB00M',
        '00cP00BB00N',
        '00cP00BB00O',
        // 撤销记录
        '00cP00BB00P',
        '00cP00BB00Q',
        '00cP00BB00R',
        // 入库过磅记录
        '00cP00BB00S',
        '00cP00BB00T',
        '00cP00BB00U',
        '00cP00BB00V',
        '00cP00BB00W',
        '00cP00BB00X',
        // 出库过磅记录
        '00cP00BB00Y',
        '00cP00BB00Z',
        '00cP00BB00a',
        '00cP00BB00b',
        '00cP00BB00c',
        '00cP00BB00d'
      ],
      title: '',
      h: '500px',
      total: 0,
      searchFrom: {
        instockDateStart: '',
        instockDateStartEnd: '',
        model: ''
      },

      pageNo: 1,
      pageSize: 20,
      customerData: [], // 货主数据
      productTypeData: [], // 货物类型
      steelMillNameData: [], // 产地
      specificationData: [], // 规格
      modelData: [], // 材质
      lengthData: [],
      specificationDisabled: true,
      steelMillNameDisabled: true,
      modelDisabled: true,
      goodsName: '',
      placeOfOrigin: '',
      specificationVal: '',
      modelVal: '',
      tableList: [],
      tabLoading: false,
      totalAllWeight: 0
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnArr, '/yycJiLuChaXun')
    this.getSeatchData()
    this.getRelationCustomer()
    this.getVirtualBalingList()
    this.getStockClearRecordWeight()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.searchClick()
      }
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 202 + 'px'
  },
  methods: {
    dateFormat (date) {
      let format = 'yyyy-MM-dd hh:mm:ss'
      if (date != 'Invalid Date') {
        var o = {
          'M+': date.getMonth() + 1, // month
          'd+': date.getDate(), // day
          'h+': date.getHours(), // hour
          'm+': date.getMinutes(), // minute
          's+': date.getSeconds(), // second
          'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
          'S': date.getMilliseconds() // millisecond
        }
        if (/(y+)/.test(format)) {
          format = format.replace(RegExp.$1,
            (date.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1,
              RegExp.$1.length == 1 ? o[k]
                : ('00' + o[k]).substr(('' + o[k]).length))
          }
        }
        return format
      }
      return ''
    },
    // 获取一级、二级客户
    getRelationCustomer () {
      getRelationCustomer().then(res => {
        this.customerData = res // 客户
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 下拉框
    getVirtualBalingList () {
      getVirtualBalingList()
        .then(res => {
          this.steelMillNameData = []
          this.specificationData = []
          this.modelData = []
          this.productTypeData = []
          var obj = {}
          for (var i = 0; i < res.length; i++) {
            if (!obj[res[i].productTypeName]) {
              this.productTypeData.push(res[i])
              obj[res[i].productTypeName] = true
            }
          }
          this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
          this.specificationData = Array.from(new Set(res.map(item => item.specification)))
          this.modelData = Array.from(new Set(res.map(item => item.model)))
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 货物类型下拉框改变事件
    productTypeChange (val) {
      // this.goodsName = val
      getVirtualBalingList({
        productType: this.searchFrom.productType,
        placeOfOrigin: this.searchFrom.steelMillName,
        specification: this.searchFrom.specification,
        model: this.searchFrom.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []

        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 产地下拉框改变事件
    steelMillNameChange (val) {
      // this.placeOfOrigin = val

      getVirtualBalingList({
        productType: this.searchFrom.productType,
        placeOfOrigin: this.searchFrom.steelMillName,
        specification: this.searchFrom.specification,
        model: this.searchFrom.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []

        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 规格下拉框改变事件
    specificationChange (val) {
      // this.specificationVal = val
      getVirtualBalingList({
        productType: this.searchFrom.productType,
        placeOfOrigin: this.searchFrom.steelMillName,
        specification: this.searchFrom.specification,
        model: this.searchFrom.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 材质下拉框改变事件
    modelChange (val) {
      // this.modelVal = val
      getVirtualBalingList({
        productType: this.searchFrom.productType,
        placeOfOrigin: this.searchFrom.steelMillName,
        specification: this.searchFrom.specification,
        model: this.searchFrom.model
      }).then(res => {
        this.lengthData = []
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 查询接口
    getSeatchData () {
      this.tabLoading = true
      getStockClearRecordList({ pageNo: this.pageNo, pageSize: this.pageSize, ...this.searchFrom })
        .then((res) => {
          this.tabLoading = false
          this.tableList = res.list
          this.total = res.total
        })
        .catch((err) => {
          this.tabLoading = false
          this.$message.error(err.message)
        })
    },
    // 查询吨数
    getStockClearRecordWeight () {
      this.tabLoading = true
      getStockClearRecordWeight({ pageNo: this.pageNo, pageSize: this.pageSize, ...this.searchFrom })
        .then((res) => {
          this.tabLoading = false
          this.totalAllWeight = res.allWeight
        })
        .catch((err) => {
          this.tabLoading = false
          this.$message.error(err.message)
        })
    },
    // 点击查询按钮
    searchClick () {
      this.getSeatchData()
      this.getStockClearRecordWeight()
    },
    // 点击重置
    chongZhiClick () {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 20
      }
      this.goodsName = ''
      this.placeOfOrigin = ''
      this.specificationVal = ''
      this.modelVal = ''
      this.getSeatchData()
      this.getVirtualBalingList()
      this.getStockClearRecordWeight()
    },
    // 每页条数
    handleSizeChange (val) {
      this.pageSize = val
      this.getSeatchData()
    },
    // 当前页
    handleCurrentChange (val) {
      this.pageNo = val
      this.getSeatchData()
    },
    // 点击选中
    handleRowClick (row) {
      this.$refs.tableRef.toggleRowSelection(row)
      this.changeFlag = row.newFlg
      this.changeData = row
      this.faBuId = row.id
      this.planStatus = row.planStatus
    },
    handleTabCurrentChange (val) {
      this.currentRow = val
    },
    // 导出
    exportClick () {
      exportExcel(
        this.global.wmsAccessName + '/shipStock/exportStockClearRecordList',
        this.searchFrom,
        '客户亏涨记录信息表'
      )
    }
  }
}
</script>
<style scoped lang='less'>
.el-table {
  overflow: visible !important;
}
/deep/.inpBox .el-input__inner {
  width: 175px;
}
.searchBox {
  margin-left: 15px;
}
.inpBox {
  margin: 5px 0 0 -40px;
}
.searchBtnBox {
  // margin-top: 10px;
  margin-left: 5px;
  margin-bottom: 0;
}
.el-table__header tr,
.el-table__header th {
  padding: 0;
  height: 40px;
}
.tongJi {
  display: flex;
  margin-left: 10px;
}
.tongJi_item {
  margin-right: 20px;
}
.tongJi_item span {
  color: red;
}
.addstyle{
  margin-left: 94%;
}
</style>
